export default __webpack_public_path__ + "static/media/fasad_pribici1.15a2ea36.jpg";